import { ZOOM_CONFIG } from './constants';

import { seriesColors, categoryAccent } from '@repo/ui/theme';

const SESSION_COLORS = [categoryAccent['session-performance'], ...seriesColors];

export const getSessionColor = (sessionIndex: number): string => {
  return SESSION_COLORS[sessionIndex % SESSION_COLORS.length];
};

export const getSessionColorByIndex = (index: number): string => {
  return SESSION_COLORS[index % SESSION_COLORS.length];
};

export interface ZoomDomain {
  xStart: Date;
  xEnd: Date;
}

export interface SessionTimeData {
  startTime: string;
  endTime: string;
}

export const calculateZoomDomain = (session: SessionTimeData): ZoomDomain => {
  const startTime = new Date(session.startTime);
  const endTime = new Date(session.endTime);

  const zoomStart = new Date(startTime.getTime() - ZOOM_CONFIG.bufferBeforeMinutes * 60 * 1000);
  const zoomEnd = new Date(endTime.getTime() + ZOOM_CONFIG.bufferAfterMinutes * 60 * 1000);

  const totalDuration = zoomEnd.getTime() - zoomStart.getTime();
  const minDuration = ZOOM_CONFIG.minTotalDurationMinutes * 60 * 1000;

  if (totalDuration < minDuration) {
    const additionalBuffer = (minDuration - totalDuration) / 2;
    zoomStart.setTime(zoomStart.getTime() - additionalBuffer);
    zoomEnd.setTime(zoomEnd.getTime() + additionalBuffer);
  }

  return { xStart: zoomStart, xEnd: zoomEnd };
};

interface DataPoint {
  timestamp: string;
  bpm: number;
}

export const filterDataByTimeRange = (data: DataPoint[], timeRange: ZoomDomain): number[] => {
  return data
    .filter(point => {
      const pointTime = new Date(point.timestamp);
      return pointTime >= timeRange.xStart && pointTime <= timeRange.xEnd;
    })
    .map(point => point.bpm);
};

export const calculateYRange = (
  values: number[],
  paddingPercent: number = 0.1,
): { min: number; max: number } => {
  if (values.length === 0) return { min: 0, max: 100 };

  const min = Math.min(...values);
  const max = Math.max(...values);
  const range = max - min;
  const padding = Math.max(5, range * paddingPercent);

  return {
    min: Math.max(0, min - padding),
    max: max + padding,
  };
};
